import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';

@inject('portalThemeStore')
@observer
class E8TopMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.onTopMenuClick = this.onTopMenuClick.bind(this);
    }

    componentDidMount() {
        jQuery('.e8header-top-menu').hover(() => {
        }, () => {
            this.onVisibleChange(false);
        });
    }

    render() {
        const {portalThemeStore} = this.props;
        const {topMenuObj, topMenuVisible} = portalThemeStore;
        const {topMenu = [], topMenuSelected = {}} = topMenuObj;
        const _topMenu = toJS(topMenu);
        const _topMenuSelected = toJS(topMenuSelected);
        const {id:selectedId} = _topMenuSelected;

        return (
            <div className={`e8header-top-menu ${topMenuVisible ? 'e8header-top-menu-open' : ''}`}>
                <div className="e8header-top-menu-items">
                    {
                        _topMenu.map((item, index) => {
                            if (item) {
                                const {id, name, fname} = item;
                                const selectedClassName = id == selectedId ? 'e8header-top-menu-item-selected' : '';

                                return (
                                    <div key={index}
                                         data-id={id}
                                         className={`e8header-top-menu-item ${selectedClassName}`}
                                         title={fname}
                                         onClick={() => this.onTopMenuClick(item)}
                                    >
                                        {name}
                                    </div>
                                );
                            } else {
                                return <div></div>;
                            }
                        })
                    }
                </div>
                <div className="e8header-top-menu-btn" onClick={() => this.onVisibleChange(!topMenuVisible)}></div>
            </div>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onTopMenuVisibleChange(visible);
    }

    onTopMenuClick(topMenuSelected) {
        this.onVisibleChange(false);

        const {portalThemeStore} = this.props;
        portalThemeStore.onTopMenuSelectedChange(topMenuSelected);
        portalThemeStore.onLeftMenuModeChange('inline');
    }
}

export default E8TopMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8TopMenu.js